import { Button, Input } from "@components/RichTextAndTypography"
import theme from "@themes/index"
import styled from "styled-components"

export const StyledInput = styled(Input)`
  transition: border-color .25s;
  
  &::placeholder {
    color: ${theme.colors.brown};
  }
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.brown};
  }
`

export const StyledButton = styled(Button)`
  transition: background, color .25s;

  @media (min-width: ${theme.sizes.maxWidth.medium}) {
    cursor: pointer;
    
    &:hover {
      &:not([disabled]) {
        background: ${theme.colors.tanDark};
        color: ${theme.colors.brown};
      }
    }

    &[disabled] {
      cursor: default;
    }
  }
`